<app-filter-panel [quickSearchFilter]="filters.name" quickSearchPlaceholder="Nombre" (search)="search()"></app-filter-panel>

<!--
<div class="flex gap-2 cola-4">
    <span class="w-full input-field p-input-icon-right">
        <input pInputText placeholder="Nombre" [(ngModel)]="filters.name.value" (keydown.enter)="search()"
            class="w-full" />
        <i *ngIf="filters.name.value" class="pi pi-times cursor-pointer"
            (click)="filters.name.value = null; search()"></i>
    </span>
</div>
-->

<p-table #grid [value]="casesStates" [lazy]="true" (onLazyLoad)="loadData($event)" [loading]="loading"
    [paginator]="true" [rows]="25" [totalRecords]="totalRecords" [showCurrentPageReport]="true"
    currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
    [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body">
    <ng-template pTemplate="header" let-columns>
        <tr>
            <th pSortableColumn="name">Nombre <p-sortIcon field="name"></p-sortIcon></th>
            <th width="300">Estilo visualización</th>
            <th width="200">Es inicial</th>
            <th width="200">Es final</th>
            <th width="200">No cambiar a citado</th>
            <th width="200" *ngFor="let caseMode of caseModes">{{caseMode.name}}</th>
            <th width="200">Sistema</th>
            <th width="100"></th>
        </tr>   
    </ng-template>
    <ng-template pTemplate="body" let-caseState let-columns="columns">
        <tr (dblclick)="edit(caseState)">
            <td>{{caseState.name}}</td>
            <td>
                <div class="p-badge" [style.backgroundColor]="caseState.backgroundColor" [style.color]="caseState.foregroundColor">{{caseState.name}}</div>
            </td>
            <td>
                <i class="pi" [ngClass]="{ 'text-green-500 pi-check-circle': caseState.isInitial, 'text-red-500 pi-times-circle': !caseState.isInitial }"></i>
            </td>
            <td>
                <i class="pi" [ngClass]="{ 'text-green-500 pi-check-circle': caseState.isFinal, 'text-red-500 pi-times-circle': !caseState.isFinal }"></i>
            </td>
            <td>
                <i class="pi" [ngClass]="{ 'text-green-500 pi-check-circle': caseState.notUpdateWhenCaseServiceConfirmed, 'text-red-500 pi-times-circle': !caseState.notUpdateWhenCaseServiceConfirmed }"></i>
            </td>
            <td *ngFor="let caseMode of caseModes">
                <i class="pi" [ngClass]="{ 'text-green-500 pi-check-circle': hasCaseMode(caseState, caseMode.id), 'text-red-500 pi-times-circle': !hasCaseMode(caseState, caseMode.id) }"></i>
            </td>
            <td>
                <i class="pi" [ngClass]="{ 'text-green-500 pi-check-circle': caseState.isSystem, 'text-red-500 pi-times-circle': !caseState.isSystem }"></i>
            </td>
            <td>
                <div class="flex gap-2 justify-content-end">
                    <p-button *ngIf="allowDelete && !caseState.isSystem" (click)="delete(caseState)" [rounded]="true" [text]="false"
                        severity="danger"><i class="pi pi-trash"></i></p-button>
                    <p-button *ngIf="allowWrite" (click)="edit(caseState)" [rounded]="true" [text]="false"><i
                            class="pi pi-pencil"></i></p-button>
                </div>
            </td>
        </tr>
    </ng-template>
</p-table>

<p-confirmDialog></p-confirmDialog>